export default () => {
    'use strict';
    function a11yClick(link:HTMLElement) {
        link.addEventListener('keydown', function(event) {
            const code = event.code;
            if (code === 'Space') {
                event.preventDefault();
                link.click();
            }
        });
    }
    const a11yLink = document.querySelectorAll('a[role="button"]');
    for ( let i = 0; i < a11yLink.length; i++ ) {
        a11yClick( a11yLink[i] as HTMLElement);
    }
}
